// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfilePdfPackCard-cls1_y5_","cls2":"ProfilePdfPackCard-cls2_YbJ ProfilePdfPackCard-cls1_y5_"};